import { useSelector } from 'react-redux';

const NawyNowFormLicenseIcon = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return isMobile ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M7.59891 1.48313L4.27224 2.73646C3.50557 3.02313 2.87891 3.92979 2.87891 4.74313V9.69646C2.87891 10.4831 3.39891 11.5165 4.03224 11.9898L6.89891 14.1298C7.83891 14.8365 9.38557 14.8365 10.3256 14.1298L13.1922 11.9898C13.8256 11.5165 14.3456 10.4831 14.3456 9.69646V4.74313C14.3456 3.92313 13.7189 3.01646 12.9522 2.72979L9.62557 1.48313C9.05891 1.27646 8.15224 1.27646 7.59891 1.48313Z"
        stroke="#1A2028"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.63867 7.91052L7.712 8.98385L10.5787 6.11719"
        stroke="#1A2028"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M6.99344 2.29563L3.66677 3.54896C2.9001 3.83563 2.27344 4.74229 2.27344 5.55563V10.509C2.27344 11.2956 2.79344 12.329 3.42677 12.8023L6.29344 14.9423C7.23344 15.649 8.7801 15.649 9.7201 14.9423L12.5868 12.8023C13.2201 12.329 13.7401 11.2956 13.7401 10.509V5.55563C13.7401 4.73563 13.1134 3.82896 12.3468 3.54229L9.0201 2.29563C8.45344 2.08896 7.54677 2.08896 6.99344 2.29563Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.03345 8.72302L7.10678 9.79635L9.97345 6.92969"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default NawyNowFormLicenseIcon;
